module.exports = __webpack_public_path__ + "static/media/Trio.24bbbfd1.png";